var map = {
	"./goldcoin/index-btn-earn.png": 73344,
	"./memetown/index-btn-earn.png": 75889,
	"./reflection/index-btn-earn.png": 22028,
	"./tapcoin/index-btn-earn.png": 3263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19526;